import React, { useState, useEffect } from 'react';
import { X, User, CreditCard, Activity, MessageSquare, DollarSign } from 'lucide-react';
import './UserDetailModal.css';

const UserDetailModal = ({ userId, onClose }) => {
    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState(null);
    const [activeTab, setActiveTab] = useState('support'); // Commence sur SUPPORT

    useEffect(() => {
        fetchData();
    }, [userId]);

    const fetchData = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(
                `http://localhost:5000/api/admin/users/${userId}/complete-profile`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            const data = await response.json();
            if (data.success) {
                setUserData(data.data);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.7)',display:'flex',alignItems:'center',justifyContent:'center',color:'white',zIndex:9999}}>Chargement...</div>;
    if (!userData) return null;

    const { user, support_tickets, statistics } = userData;

    return (
        <div onClick={onClose} style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.8)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999,padding:20}}>
            <div onClick={e => e.stopPropagation()} style={{background:'white',borderRadius:16,width:'90%',maxWidth:900,maxHeight:'90vh',overflow:'auto'}}>
                
                {/* HEADER */}
                <div style={{padding:24,background:'linear-gradient(135deg,#1e293b,#334155)',color:'white',borderRadius:'14px 14px 0 0',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                    <div style={{display:'flex',gap:16,alignItems:'center'}}>
                        <div style={{width:60,height:60,background:'linear-gradient(135deg,#3b82f6,#8b5cf6)',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center'}}>
                            <User size={32} />
                        </div>
                        <div>
                            <h2 style={{margin:0}}>{user.username}</h2>
                            <p style={{margin:'4px 0'}}>{user.email}</p>
                            <span style={{background:'#fef3c7',color:'#92400e',padding:'4px 12px',borderRadius:12,fontSize:12,fontWeight:600}}>{user.role}</span>
                        </div>
                    </div>
                    <button onClick={onClose} style={{background:'rgba(255,255,255,0.1)',border:'none',color:'white',padding:8,borderRadius:8,cursor:'pointer'}}>
                        <X size={24} />
                    </button>
                </div>

                {/* TABS */}
                <div style={{display:'flex',borderBottom:'2px solid #e5e7eb',padding:'0 24px',background:'#f9fafb'}}>
                    {['overview','support'].map(tab => (
                        <button
                            key={tab}
                            onClick={() => setActiveTab(tab)}
                            style={{
                                display:'flex',alignItems:'center',gap:8,padding:'16px 24px',background:'none',border:'none',
                                cursor:'pointer',color:activeTab===tab?'#2563eb':'#6b7280',fontWeight:500,
                                borderBottom:activeTab===tab?'3px solid #2563eb':'3px solid transparent'
                            }}
                        >
                            {tab === 'overview' ? <User size={16} /> : <MessageSquare size={16} />}
                            <span>{tab === 'overview' ? 'Vue d\'ensemble' : 'Support Tickets'}</span>
                        </button>
                    ))}
                </div>

                {/* CONTENT */}
                <div style={{padding:24}}>
                    {activeTab === 'overview' && (
                        <div>
                            <h3>Statistiques</h3>
                            <div style={{display:'grid',gridTemplateColumns:'repeat(2,1fr)',gap:16}}>
                                <div style={{padding:20,background:'#f9fafb',borderRadius:12,textAlign:'center'}}>
                                    <CreditCard size={24} />
                                    <p>Crédits: {user.remaining_credits}</p>
                                </div>
                                <div style={{padding:20,background:'#f9fafb',borderRadius:12,textAlign:'center'}}>
                                    <MessageSquare size={24} />
                                    <p>Conversations: {statistics.total_conversations}</p>
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === 'support' && (
                        <div>
                            <h3>🎫 Tickets Support ({support_tickets.length})</h3>
                            {support_tickets.length === 0 ? (
                                <p style={{textAlign:'center',padding:40,color:'#9ca3af'}}>Aucun ticket support</p>
                            ) : (
                                support_tickets.map(ticket => (
                                    <div key={ticket.id} style={{background:'white',border:'2px solid #e5e7eb',borderRadius:12,padding:16,marginBottom:12}}>
                                        <div style={{display:'flex',gap:8,marginBottom:8}}>
                                            <span style={{background:'#ef4444',color:'white',padding:'4px 8px',borderRadius:4,fontSize:12,fontWeight:600}}>{ticket.priority}</span>
                                            <span style={{background:'#3b82f6',color:'white',padding:'4px 8px',borderRadius:4,fontSize:12,fontWeight:600}}>{ticket.status}</span>
                                        </div>
                                        <h4 style={{margin:'8px 0'}}>{ticket.subject}</h4>
                                        <p><strong>Catégorie:</strong> {ticket.category}</p>
                                        <p><strong>Ticket:</strong> #{ticket.ticket_number}</p>
                                        <small>{new Date(ticket.created_at).toLocaleString('fr-FR')}</small>
                                    </div>
                                ))
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default UserDetailModal;